// extracted by mini-css-extract-plugin
export default {"backButton":"xOBRkWZlDprCNs0kclKXUA==","subtitle":"dLN-9QF4qpo8xKROaYrKMw==","selectorItem":"YvRR1gOhVb8ioSQDE2Ngfw=="};